module.exports = __webpack_public_path__ + "static/star-trek-pano-0d2315ceadfa61303398f8140f673aaf.jpg";